import routerOptions0 from "/Users/id30-cyrus/Documents/Codex/iD30/EPC - Solar Landing Page v3/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}